import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";

import hero1 from "../../images/slider/slide-4.jpg";
import hero2 from "../../images/slider/slide-6.jpg";
import hero3 from "../../images/slider/slide-5.jpg";

const Hero4 = ({ lang }) => {
    const { t } = useTranslation(); // Translation hook
    const settings = {
        dots: false,
        arrows: true,
        speed: 1200,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        fade: true,
        rtl: lang === "ar", // Enable RTL for Arabic
    };

    const singleImage = hero1; // Image to display for Arabic

    return (
        <section className="wpo-hero-slider wpo-hero-style-3">
            <div className="wpo-line-animated">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div className="hero-container">
                <div className="hero-wrapper">
                    {lang === "ar" ? (
                        // Render single image for Arabic
                        <div className="hero-slide">
                            <div
                                className="slide-inner"
                                style={{
                                    backgroundImage: `url(${singleImage})`,
                                }}
                            >
                                <div className="container-fluid">
                                    <div className="slide-content">
                                        <div className="slide-title">
                                            <h2>{t("hero.title")}</h2>
                                        </div>
                                        <div className="slide-btns">
                                            <Link to="/about" className="theme-btn">
                                                {t("hero.learnMore")}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        // Render slider for other languages
                        <Slider {...settings}>
                            {[hero1, hero2, hero3].map((heroImage, index) => (
                                <div className="hero-slide" key={index}>
                                    <div
                                        className="slide-inner"
                                        style={{
                                            backgroundImage: `url(${heroImage})`,
                                        }}
                                    >
                                        <div className="container-fluid">
                                            <div className="slide-content">
                                                <div className="slide-title">
                                                    <h2>{t("hero.title")}</h2>
                                                </div>
                                                <div className="slide-btns">
                                                    <Link to="/about" className="theme-btn">
                                                        {t("hero.learnMore")}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Hero4;
